/** EVI-709: Shown when an existing chat has no messages (distinct from ChatEmptyState for new chats). */

import { IS_INSET_DESIGN_ENABLED } from '@/features/flags/legacy-flags';
import {
  TypographyCaption,
  TypographyP2,
} from '@heidi/design-system/typography';
import { cn } from '@/lib/cn';
import { FormattedMessage } from 'react-intl';
import { chatEmptyConversationMessages } from './ChatEmptyConversation.messages';

export const ChatEmptyConversation = () => {
  return (
    <div
      className={cn(
        'flex size-full flex-col items-center justify-center gap-2',
        IS_INSET_DESIGN_ENABLED() ? 'bg-surface-shell' : 'bg-surface-page'
      )}
    >
      <TypographyP2 className="text-text-secondary">
        <FormattedMessage {...chatEmptyConversationMessages.emptyConversation} />
      </TypographyP2>
      <TypographyCaption className="text-text-tertiary">
        <FormattedMessage {...chatEmptyConversationMessages.sendMessageToStart} />
      </TypographyCaption>
    </div>
  );
};
